import {
  Component,
  ViewEncapsulation,
  OnInit, Inject, OnDestroy, ViewChild, AfterViewInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult,
  RowArgs, SelectionEvent
} from '@progress/kendo-angular-grid';

import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../../../../services/user-context/user-context';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../../../../services/api/api.service';
import {DOCUMENT} from '@angular/common';
import {BehaviorSubject, Observable, Subscription, of as observableOf} from 'rxjs';
import {ImportClientsService} from './import-clients.service';
import {UserDialogComponent} from '../users/user-dialog.component';
import {ImportDialogComponent} from './import-dialog.component';

@Component({
  selector: 'app-import',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'import.template.html'
})
export class ImportComponent implements OnInit, OnDestroy {

  public importsView: Observable<GridDataResult>;


  public importsState: State = {
    skip: 0,
    take: 10
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private importsService: ImportClientsService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private userContext: UserContext,
    @Inject(DOCUMENT) private document: Document) {

    this.importsView = this.importsService;
  }

  public ngOnInit(): void {
    this.getImports();
  }

  public ngOnDestroy(): void {
  }


  public importsStateChange(state: DataStateChangeEvent): void {
    this.importsState = state;
    this.getImports();
  }

  public importClients(): void {
    const dialogRef = this.dialog.open(ImportDialogComponent, {
      width: '650px'
    });

    dialogRef.afterClosed().subscribe(dataImport => {
      if ( dataImport ) {
        this.getImports();
          this.snackBar.open('Uploaded import.', null, {
            duration: 2000
          });
        }
    });
  }

  public getImports() {
    const page = this.importsState.skip / this.importsState.take + 1;
    const limit = this.importsState.take;

    this.importsService.getImports( page, limit, () => {

    });
  }

}
